interface ConfigBody {
  clientId: string
  baseUrl: string
}

export interface Config {
  [propertyName: string]: ConfigBody
}

const envConfig: Config = {
  development: {
    clientId: 'npjs1ubfnbxqqhmjxazbfy0cosfq4s4',
    baseUrl: 'https://dev-v2.bundleb2b.net/api',
  },
  staging: {
    clientId: 'r2x8j3tn54wduq47b4efct5tqxio5z2',
    baseUrl: 'https://staging-v2.bundleb2b.net',
  },
  production: {
    clientId: 'dl7c39mdpul6hyc489yk0vzxl6jesyx',
    baseUrl: 'https://api.bundleb2b.net',
  },
}

export default envConfig
